import * as React from 'react';
import { Checkbox } from '@cian/ui-kit';

import * as styles from './MultiPosting.css';
import { PlatformsLinkContainer } from './PlatformsLink';
import { mergeStyles } from '@cian/utils';
import fireIcon from './assets/fire.png';

interface IProps {
  isMobile: boolean;
  checked: boolean;
  text: string;
  labelText: string;
  termsUrl: string;
  onChange(checked: boolean): void;
}

export function MultiPosting({ isMobile, checked, text, labelText, termsUrl, onChange }: IProps) {
  const termsText = 'мультиразмещения.';
  const terms = termsUrl ? (
    <a href={termsUrl} target="_blank" rel="noreferrer">
      {termsText}
    </a>
  ) : (
    termsText
  );

  const handleChange = () => {
    onChange(!checked);
  };

  return (
    <div className={styles['container']}>
      <div {...mergeStyles(styles['checkbox'], isMobile && styles['checkbox-mobile'])}>
        <Checkbox checked={checked} onChange={handleChange} />
      </div>
      <div className={styles['body']}>
        <div {...mergeStyles(styles['header'], isMobile && styles['header-mobile'])}>
          <div className={styles['text']} onClick={handleChange}>
            Разместить на других площадках
          </div>
          {labelText && (
            <div className={styles['label']}>
              <img className={styles['fire-icon']} src={fireIcon} />
              {labelText}
            </div>
          )}
        </div>
        <div className={styles['info']}>
          <div>Получите больше просмотров и звонков с помощью {terms}</div>
          <div>
            {text}&nbsp;
            <PlatformsLinkContainer />
          </div>
        </div>
      </div>
    </div>
  );
}
